import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CourseCard from "../../Components/CourseCard.jsx";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import { IoMdAdd, IoMdArrowRoundBack } from "react-icons/io";
import {
  useGetAdminUsingEmailQuery,
  useGetAllCoursesQuery,
  useRemoveCourseMutation,
} from "../../../../graphql/generated.tsx";
import { toast } from "../../../../toast";
import Loader from "../../../../components/Loader.jsx";

const Courses = () => {
  const { data, loading, refetch } = useGetAllCoursesQuery();
  const [deleteCourse] = useRemoveCourseMutation();
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [Isload, setIsload] = useState(true);

  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const { data: admin } = useGetAdminUsingEmailQuery({
    variables: { email },
    skip: !email,
  });


  useEffect(() => {
    refetch();
    if (data) {
      if (admin?.getAdminUsingEmail?.isSuperAdmin) {
        setFilteredCourses(data?.getAllCourses);
      } else {
        const courses = data?.getAllCourses.filter((course) =>
          admin?.getAdminUsingEmail?.permissions?.courses.includes(course.id)
        );
        setFilteredCourses(courses);
      }
    }
  }, [data, admin]);
   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);
  

  const handleDelete = async (id) => {
    await deleteCourse({ variables: { id } });
    refetch();
    toast.success("Deleted Successfully");
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
        <Loader />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-8 bg-white">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              All Courses
            </div>
          </div>
          {admin?.getAdminUsingEmail?.isSuperAdmin && (
            <Link
              to="/admin/courses/create-course"
              className="flex items-center px-3 py-1 text-white rounded-lg shadow-md w-300px bg-primary"
            >
              <IoMdAdd className="mt-1 mr-1" /> <span>Create Course</span>
            </Link>
          )}
        </div>
        <div className="flex flex-wrap items-stretch gap-6">
          {filteredCourses?.map((course) => (
            <div
              key={course.id}
              className="flex w-full sm:w-[calc(50%-0.75rem)] xl:w-[370px]"
            >
              <CourseCard
                course_id={course.id}
                name={course.name}
                short_description={course.short_description}
                time_period={course.time_period}
                onRemove={handleDelete}
                isSuperAdmin={admin?.getAdminUsingEmail?.isSuperAdmin}
                level={course.level}
                domain={course.domain}
                price={course.price}
                languages={course.languages || []}
                categories={course.categories || []}
                benefits={course.benefits || []}
                numQuestions={course.question_ids?.length || 0}
                updatedAt={course.updatedAt}
              />
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default Courses;
